import { ElementRef, OnInit, DoCheck } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";
import { FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
//snackbar 1
import { MatSnackBar } from '@angular/material';
import { environment } from "environments/environment";
import { Router } from '@angular/router';
//ngx-webcam 1
import { Subject } from 'rxjs';
import { WebcamUtil } from 'ngx-webcam';
import { GLOBALService } from "../../../servicios/functions/GLOBAL.service";
var ELEMENT_DATA = [];
var ELEMENT_DATA4 = [];
var VerdetallesComponent = /** @class */ (function () {
    function VerdetallesComponent(http, dialog, datePipe, 
    //snackbar 2
    snackBar, router, global) {
        this.http = http;
        this.dialog = dialog;
        this.datePipe = datePipe;
        this.snackBar = snackBar;
        this.router = router;
        this.global = global;
        //ngx-webcam 2
        // toggle webcam on/off
        this.showWebcam = true;
        this.allowCameraSwitch = true;
        this.multipleWebcamsAvailable = false;
        this.videoOptions = {};
        this.errors = [];
        // latest snapshot
        this.webcamImage = null;
        // webcam snapshot trigger
        this.trigger = new Subject();
        // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
        this.nextWebcam = new Subject();
        this.FECHA_CARGA = new Date;
        this.uploader = new FileUploader({
            url: environment.backendUrl + "/api/importador/importar",
            itemAlias: 'foto',
            headers: [{ name: 'Access-Control-Allow-Origin', value: '*' }]
        });
        this.booleano = false;
        this.displayedColumns = ['select', 'COD_DETALLE', 'FECHA_CARGA', 'FECHA_TICKET', 'DETALLE', 'IMPORTE', 'CATEGORIA', 'OBSERVACIONES', 'IMAGEN'];
        this.dataSource = new MatTableDataSource(ELEMENT_DATA);
        this.selection = new SelectionModel(true, []);
        //rotar imagen a lo mand
        this.cont = 0;
        this.loading = true;
    }
    VerdetallesComponent.prototype.ngDoCheck = function () {
        console.log(this.DETALLE);
    };
    VerdetallesComponent.prototype.getFiles = function (event) {
        this.files = event.target.files;
        var reader = new FileReader();
        reader.onload = this._handleReaderLoaded.bind(this);
        reader.readAsDataURL(this.files[0]);
    };
    //obtengo base64 de imagen subida
    VerdetallesComponent.prototype._handleReaderLoaded = function (readerEvt) {
        var b64String = readerEvt.target.result;
        this.fotob64 = b64String;
        //console.log(this.fotob64);
    };
    VerdetallesComponent.prototype.transformDate = function (date) {
        this.datePipe.transform(this.FECHA_CARGA, 'yyyy-MM-dd'); //whatever format you need. 
    };
    VerdetallesComponent.prototype.selectRow = function (row, det, imp, fec, img, obs) {
        this.codi_detalle_edit = row;
        this.det_edit = det;
        this.imp_edit = imp;
        this.fec_edit = fec;
        this.fotito = img;
        this.obs = obs;
        console.log(this.codi_detalle_edit);
    };
    VerdetallesComponent.prototype.applyFilter = function (filterValue) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    };
    //Si el número de elementos seleccionados coincide con el número total de filas..
    VerdetallesComponent.prototype.isAllSelected = function () {
        var numSelected = this.selection.selected.length;
        var numRows = this.dataSource.data.length;
        return numSelected === numRows;
    };
    //Selecciona todas las filas si no están todas seleccionadas; de lo contrario, borra la seleccion
    VerdetallesComponent.prototype.masterToggle = function () {
        var _this = this;
        this.isAllSelected() ?
            this.selection.clear() :
            this.dataSource.data.forEach(function (row) { return _this.selection.select(row); });
    };
    VerdetallesComponent.prototype.addEvent = function (input, $event) {
        this.selectedDate = moment($event.value).format('YY-MM-DD');
        this.FECHA_TICKET = this.selectedDate;
        moment(this.FECHA_TICKET).format('YYYY-MM-DD');
        console.log("FECHA DEL TICKET NUEVO:" + this.FECHA_TICKET);
    };
    VerdetallesComponent.prototype.ngOnInit = function () {
        var _this = this;
        window.scroll(0, 0);
        //lleno categorias
        this.role = localStorage.getItem('role');
        this.llenarCategorias();
        ////ngx-webcam 3
        WebcamUtil.getAvailableVideoInputs()
            .then(function (mediaDevices) {
            _this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
        });
        //
        this.estadoGasto = localStorage.getItem('estadoGasto');
        localStorage.removeItem('arrayGastoPrint');
        this.detalleGasto = localStorage.getItem('detalleGasto');
        this.tot_gasto = localStorage.getItem("imp_gasto");
        this.fecha_hoy = this.datePipe.transform(this.FECHA_CARGA, "yyyy-MM-dd");
        console.log(this.fecha_hoy);
        console.log(this.datePipe.transform(this.FECHA_CARGA, "yyyy-MM-dd"));
        this.codgas = localStorage.getItem('codgasto_edit');
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        setTimeout(function () {
            console.log("cargando grid..");
            _this.cargaGrid();
        }, 1000);
    };
    VerdetallesComponent.prototype.llenarCategorias = function () {
        var _this = this;
        //http://localhost:1337/api/llenarcategorias/ver?rol=PAGADOR
        this.http.get(environment.backendUrl + "/api/llenarcategorias/ver?rol=" + this.role)
            .subscribe(function (data) {
            _this.dataSourceCategorias = data;
            console.log(_this.dataSourceCategorias);
        });
    };
    //ngx-webcam 3
    VerdetallesComponent.prototype.triggerSnapshot = function () {
        this.trigger.next();
    };
    VerdetallesComponent.prototype.toggleWebcam = function () {
        this.showWebcam = !this.showWebcam;
    };
    VerdetallesComponent.prototype.handleInitError = function (error) {
        this.errors.push(error);
    };
    VerdetallesComponent.prototype.showNextWebcam = function (directionOrDeviceId) {
        // true => move forward through devices
        // false => move backwards through devices
        // string => move to device with given deviceId
        this.nextWebcam.next(directionOrDeviceId);
    };
    VerdetallesComponent.prototype.handleImage = function (webcamImage) {
        console.info('received webcam image', webcamImage);
        this.webcamImage = webcamImage;
        //console.log(this.webcamImage.imageAsDataUrl);
        //hago el resize de la fotodetalle antes de guardarlo
        console.log("resize imagen desde webcam..");
        this.fotodetalle = this.webcamImage.imageAsDataUrl;
    };
    VerdetallesComponent.prototype.cameraWasSwitched = function (deviceId) {
        console.log('active device: ' + deviceId);
        this.deviceId = deviceId;
    };
    Object.defineProperty(VerdetallesComponent.prototype, "triggerObservable", {
        get: function () {
            return this.trigger.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VerdetallesComponent.prototype, "nextWebcamObservable", {
        get: function () {
            return this.nextWebcam.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    VerdetallesComponent.prototype.limpiacam = function () {
        this.showWebcam = false;
        this.fotodetalle = [];
        this.fotodetalle = null;
        this.webcamImage = null;
    };
    // fin ngx-webcam 
    VerdetallesComponent.prototype.ngAfterViewInit = function () {
    };
    VerdetallesComponent.prototype.cargaGrid = function () {
        var _this = this;
        this.http.get(environment.backendUrl + "/api/vergastos/detalle?codgas=" + this.codgas + "&ima=SI")
            .subscribe(function (data) {
            _this.dataSource.data = data;
            _this.loading = false;
        });
        console.log("grid cargado..");
    };
    VerdetallesComponent.prototype.exportAsExcel = function () {
        var ws = XLSX.utils.table_to_sheet(this.table.nativeElement); //converts a DOM TABLE element to a worksheet
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, "Gastos-" + localStorage.getItem('apellidonombre') + "_viaje.xlsx");
    };
    VerdetallesComponent.prototype.enviarCodDetalle = function () {
        //al hacer click en editar en el modal, envio al local storage el codigo de gasto a editar
        localStorage.setItem('coddetalle_edit', "" + this.codi_detalle_edit);
        console.log(localStorage.getItem('coddetalle_edit'));
    };
    VerdetallesComponent.prototype.volver = function () {
        localStorage.removeItem('codgasto_edit');
        this.codgas = null;
        console.log("borro el codgasto to_edit");
    };
    VerdetallesComponent.prototype.insertarNuevo = function () {
        var _this = this;
        var data = {
            cod_gasto: this.codgas,
            fecha_hoy: moment(this.fecha_hoy).format('YYYY-MM-DD'),
            fecha_ticket: moment(this.FECHA_TICKET).format('YYYY-MM-DD'),
            detalle: this.DETALLE,
            importe: this.IMPORTE,
            categoria: this.CATEGORIA,
            observaciones: this.OBSERVACIONES,
            imagen: this.fotodetalle
        };
        ELEMENT_DATA4.push(data);
        console.log("asi queda el registro");
        console.log(data["cod_gasto"]);
        console.log(data["fecha_hoy"]);
        console.log(data["fecha_ticket"]);
        console.log(data["detalle"]);
        console.log(data["importe"]);
        console.log(data["categoria"]);
        console.log(data["observaciones"]);
        console.log(data["imagen"]);
        this.loading = true;
        this.http.post(environment.backendUrl + "/api/insertadetalle/insertarpost", {
            'codgasto': data["cod_gasto"],
            'fecha_hoy': data["fecha_hoy"],
            'fecha_ticket': data["fecha_ticket"],
            'detalle': data["detalle"],
            'importe': data["importe"],
            'categoria': data["categoria"],
            'observaciones': data["observaciones"],
            'imagen': data["imagen"]
        }, {
            responseType: 'text'
        }).subscribe(function (res) {
            console.log(res);
            console.log("Inserto ok el nuevo subgasto!");
            _this.loading = false;
            _this.snackBar.open('SubGasto añadido correctamente!', 'Cerrar', { duration: 3000 });
            _this.global.historicalTo("+SUMO UN TICKET NUEVO AL GASTO COD [" + _this.codgas + "], det: *" + _this.DETALLE + "*, de fecha: " + _this.FECHA_TICKET + ", catego: " + _this.CATEGORIA + ", importe: $" + _this.IMPORTE + ", a las " + _this.global.horario(), 'AÑADE-SUBGASTO');
        }, function (err) {
            console.log("salio por error!!!!!!");
            console.log(err);
        });
        /*
        console.log("INSERTA NUEVO!");
        //calcula fecha hoy
        console.log(this.fotodetalle);
        this.http.get(`${environment.backendUrl}/api/insertadetalle/detalle_insertar?codgas=${this.codgas}&fecha_hoy=${this.fecha_hoy}&fecha_ticket=${this.FECHA_TICKET}&detalle=${this.DETALLE}&importe=${this.IMPORTE}&categoria=${this.CATEGORIA}&observaciones=${this.OBSERVACIONES}`)
        .subscribe((data: any) => {
          this.result = JSON.stringify(data["affectedRows"]);
          if (this.result==1){
            
            console.log(`DETALLE NUEVO INSERTADO PARA AEL GASTO COD: ${this.codgas} ** INSERTADO ** correctamente de la bd!`);
            // snackbar si encuentra al usuario
            this.snackBar.open('Añaido correctamente!', 'Cerrar', {duration: 4000});
            this.cargaGrid();
            this.fotodetalle=null;
            this.fotob64=null;
            this.limpiacam();
            
          }else{
            this.limpiacam();
            console.log(`SURGIO UN ERROR AL INSERTAR NUEVO DETALLE..`);
            this.snackBar.open('Error al añadir el nuevo sub-gasto', 'Cerrar', {duration: 4000});
          }
        });
    
      */
    };
    VerdetallesComponent.prototype.download = function () {
        //return a promise that resolves with a File instance
        function urltoFile(url, filename, mimeType) {
            mimeType = mimeType || (url.match(/^data:([^;]+);/) || '')[1];
            return (fetch(url)
                .then(function (res) { return res.arrayBuffer(); })
                .then(function (buf) { return new File([buf], filename, { type: mimeType }); }));
        }
        //Usage example:
        urltoFile(this.fotito, 'ticketgasto', 'png')
            .then(function (file) {
            console.log(file);
        });
    };
    VerdetallesComponent.prototype.snackCamara = function () {
        // snackbar si encuentra al usuario
        this.snackBar.open('IMAGEN LISTA!!!', 'Cerrar', { duration: 3000 });
    };
    VerdetallesComponent.prototype.quitarImagen = function () {
        this.fotodetalle = null;
        this.limpiacam();
    };
    VerdetallesComponent.prototype.imprimirGastos = function () {
        console.log("enviando al local storage.. arrayGastoPrint");
        localStorage.setItem('arrayGastoPrint', JSON.stringify(this.dataSource.data));
        //console.log(JSON.parse(localStorage.getItem('arrayGastoPrint')));
        //this.router.navigate(['/print-gastos']); 
    };
    /*migra a webcam*/
    VerdetallesComponent.prototype.prendeCamara = function () {
        //prende ngx-webcam 4
        this.showWebcam = true;
    };
    //tocar imagen
    VerdetallesComponent.prototype.fullscreen = function () {
        document.getElementById("fotocopia").requestFullscreen();
    };
    VerdetallesComponent.prototype.rotate = function () {
        this.cont = this.cont + 90;
        var img = document.getElementById("fotocopia");
        img.style.webkitTransform = this.cont + "deg";
        img.style.rotate = this.cont + "deg";
        img.style.transform = "rotate(" + this.cont + "deg)";
    };
    return VerdetallesComponent;
}());
export { VerdetallesComponent };
